<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Department of Agri Product Sale and Marketing/ B2B Contract Quota
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 6 || roleid == 7">
        <b-tab-item label="B2B">
          <div class="columns scrollme">
            <div class="column">
              <b-filed>
                <b-field group>
                  <b-field label="ຄວາມຕ້ອງການຕາມ B2B (ແຜນຜະລິດ)"></b-field>
                  <b-field style="margin: 0 10px 0 10px;">
                    <router-link to="/dasm/setting/b2buser">
                      <b-button
                        class="btn-group-margin"
                        type="is-primary"
                        size="is-small"
                        >ຈັດການ B2B
                      </b-button>
                    </router-link>
                  </b-field>
                </b-field>

                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ຊື່ B2B
                      </th>
                      <th class="has-text-left " width="15%">
                        ແຂວງ
                      </th>
                      <th class="has-text-left " width="15%">
                        ເມືອງ
                      </th>
                      <th class="has-text-left " width="30%">
                        ບ້ານ
                      </th>
                      <th class="has-text-left " width="30%">
                        ຈຳນວນສັນຍາ
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in activeb2b" :key="data.USERID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.FULLNAME }}
                      </td>
                      <td>
                        {{ data.PROVINCENAME }}
                      </td>
                      <td>
                        {{ data.DISTRICT }}
                      </td>
                      <td>
                        {{ data.VILLAGE }}
                      </td>
                      <td class="has-text-right">
                        {{ data.COUNTCONTRACT }}
                      </td>

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="contractform(data.USERID, data.USERNAME)"
                              >ຟອມສັນຍາ 
                            </b-button>
                          </b-field>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-filed>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="ຟອມສັນຍາ">
          <b-field v-if="b2busername === null">
            <button class="button is-info" @click="gotoB2Blist">
              ເລືອກ B2B
            </button>
          </b-field>
          <b-filed v-else>
            <div class="columns">
              <div class="column">
                <h3 class="title">{{ b2busername }}</h3>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field label="ຟອມສັນຍາ  (ແຜນຜະລິດ)"></b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <div class="columns">
                  <div class="column">
                    ສັນຍາຫຼັກເລກທີ <span class="asterisk">*</span>
                    <b-field label="">
                      <b-input v-model.trim="contractno"> </b-input>
                    </b-field>
                  </div>
                  <div class="column">
                    ສັນຍາຍ່ອຍເລກທີ <span class="asterisk">*</span>
                    <b-field label="">
                      <b-input v-model.trim="subcontractno"> </b-input>
                    </b-field>
                  </div>
                  <div class="column">
                    ວັນທີສັນຍາ
                    <b-field>
                      <b-datepicker
                        :date-formatter="dateFormatter"
                        v-model="selecteddate"
                        @input="onSelecteddate"
                      >
                      </b-datepicker>
                    </b-field>
                  </div>
                  <div class="column">
                    ລາຍລະອຽດ 
                    <b-field label="">
                      <b-input v-model.trim="contractdetail"> </b-input>
                    </b-field>
                  </div>
                </div>

                <div class="columns">
                  <div class="column">
                    ປະເທດ <span class="asterisk">*</span>
                    <b-field label="">
                      <Multiselect
                        placeholder="ເລືອກ"
                        v-model.trim="SelectedCountry"
                        label="NAME"
                        track-by="ID"
                        :options="countryList"
                        @input="onCountrySelected"
                      >
                      </Multiselect>
                    </b-field>
                  </div>
                  <div class="column">
                    ແຂວງ <span class="asterisk">*</span>
                    <b-field label="">
                      <Multiselect
                        placeholder="ເລືອກ"
                        v-model.trim="SelectedProvince"
                        label="NAME"
                        track-by="ID"
                        :options="ProvinceList"
                      >
                      </Multiselect>
                    </b-field>
                  </div>
                  <div class="column">
                    ເມືອງ <span class="asterisk">*</span>
                    <b-field label="">
                      <b-input v-model.trim="district"> </b-input>
                    </b-field>
                  </div>
                  <div class="column">
                    ບ້ານ <span class="asterisk">*</span>
                    <b-field label="">
                      <b-input v-model.trim="village"> </b-input>
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  
                  <div class="column">
                    ເລືອກແຂວງຜະລິດ <span class="asterisk">*</span>
                    <b-field label="" >
                      <Multiselect
                        placeholder="ເລືອກ"
                        v-model.trim="SelectedDppProvince"
                        label="DPPPROVINCENAME"
                        track-by="DPPPROVINCEID"
                        :options="DppProvinceList"
                      >
                      </Multiselect>
                      
                    </b-field>
                  </div>
                  <div class="column">
                    ເລືອກສາງເກັບສິນຄ້າ <span class="asterisk">*</span>
                    <b-field label="">
                      <Multiselect
                        placeholder="ເລືອກ"
                        v-model.trim="selectedStock"
                        label="NAME"
                        track-by="ID"
                        :options="stockList"
                      >
                      </Multiselect>
                    </b-field>
                  </div>
                  <div class="column"></div>
                  <div class="column"></div>
                </div>

                <b-field label="" style="float: right">
                  <b-field v-if="saveAction">
                    <button class="button is-info" @click="saveContract">
                      ບັນທຶກ
                    </button>
                  </b-field>
                  <b-field v-if="updateAction">
                    <div class="columns">
                      <div class="column">
                        <b-field>
                          <button
                            class="button is-primary"
                            @click="updateFarmer"
                          >
                            ແກ້ໄຂ
                          </button>
                        </b-field>
                      </div>
                      <div class="column">
                        <b-field>
                          <button
                            class="button is-info"
                            @click="openSaveFarmerForm"
                          >
                            ຟອມເພີ່ມສັນຍາ
                          </button>
                        </b-field>
                      </div>
                    </div>
                  </b-field>
                </b-field>
              </div>
            </div>

            <b-field>
              <b-tabs v-model="activeQuotaProgressTab">
                <b-tab-item label="ລໍຖ້າສົ່ງແຜນ">
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="10%">
                          ສັນຍາເລກທີ/ <br />ເລກທີຍ່ອຍ
                        </th>
                        <th class="has-text-left " width="10%">
                          ວັນທີສັນຍາ
                        </th>
                        <th class="has-text-left " width="15%">
                          ວັນທີສົ່ງລາຍການ
                        </th>
                        <th class="has-text-left " width="10%">
                          ຈຳນວນ<br />ຜະລິດ/ເກັບກ່ຽວ
                        </th>
                        <th class="has-text-left " width="25%">
                          ສະຖານທີ່ຮັບສິນຄ້າ
                        </th>
                        <!-- <th class="has-text-left " width="10%">
                            ລາຍລະອຽດ
                          </th> -->
                        <th class="has-text-centered " width="10%">
                          ສະຖານະ
                        </th>
                        <th class="has-text-centered " width="10%">
                          ຈັດການ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in contractlist_waittoproduce"
                        :key="data.ID"
                      >
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td>{{ data.CONTRACTNO }}/ {{ data.SUBCONTRACTNO }}</td>
                        <td>
                          {{ dateFormatter(data.CONTRACTDATE) }}
                        </td>
                        <td>
                          {{ dateFormatter(data.SUMMITDATE) }}
                        </td>
                        <td>
                          {{ data.NUMBEROFPRODUCTS }} / {{ data.NUMOFHARVEST }}
                        </td>
                        <td>
                          {{ data.PROVINCENAME }} {{ data.DISTRICT }}
                          {{ data.VILLAGE }}
                        </td>
                        <!-- <td>
                            {{ data.DETAIL }}
                          </td> -->
                        <td class="has-text-centered">
                          <b-field v-if="data.STATUS == 1">
                            <b-button type="is-warning" size="is-small"
                              >ລໍຖ້າສົ່ງແຜນ
                            </b-button>
                          </b-field>
                          <b-field v-else-if="data.STATUS == 2">
                            <b-button type="is-warning" size="is-small"
                              >ສົ່ງແຜນແລ້ວ, ລໍຖ້າຜະລິດ
                            </b-button>
                          </b-field>
                        </td>

                        <td class="has-text-centered">
                          <b-field group>
                            <b-field>
                              <b-button
                                class="btn-group-margin"
                                type="is-primary"
                                size="is-small"
                                @click="
                                  quotadetailform(
                                    data.ID,
                                    data.B2BUSERNAME,
                                    data.CONTRACTNO,
                                    data.SUBCONTRACTNO,
                                    data.CONTRACTDATE,
                                    data.SELECTEDDPPBRANCHID,
                                    data.SELECTEDDPPPROVINCE,
                                    data.STATUS
                                  )
                                "
                                >ລາຍລະອຽດ
                              </b-button>
                            </b-field>
                          </b-field>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-tab-item>
                <b-tab-item label="ຂະບວນການຜະລິດ">
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="10%">
                          ສັນຍາເລກທີ/ <br />ເລກທີຍ່ອຍ
                        </th>
                        <th class="has-text-left " width="10%">
                          ວັນທີສັນຍາ
                        </th>
                        <th class="has-text-left " width="15%">
                          ວັນທີສົ່ງລາຍການ
                        </th>
                        <th class="has-text-left " width="10%">
                          ຈຳນວນ<br />ຜະລິດ/ເກັບກ່ຽວ
                        </th>
                        <th class="has-text-left " width="25%">
                          ສະຖານທີ່ຮັບສິນຄ້າ
                        </th>
                        <!-- <th class="has-text-left " width="10%">
                            ລາຍລະອຽດ
                          </th> -->
                        <th class="has-text-centered " width="10%">
                          ສະຖານະ
                        </th>
                        <th class="has-text-centered " width="10%">
                          ຈັດການ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in contractlist_producing"
                        :key="data.ID"
                      >
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td>{{ data.CONTRACTNO }}/ {{ data.SUBCONTRACTNO }}</td>
                        <td>
                          {{ dateFormatter(data.CONTRACTDATE) }}
                        </td>
                        <td>
                          {{ dateFormatter(data.SUMMITDATE) }}
                        </td>
                        <td>
                          {{ data.NUMBEROFPRODUCTS }} / {{ data.NUMOFHARVEST }}
                        </td>
                        <td>
                          {{ data.PROVINCENAME }} {{ data.DISTRICT }}
                          {{ data.VILLAGE }}
                        </td>
                        <!-- <td>
                            {{ data.DETAIL }}
                          </td> -->
                        <td class="has-text-centered">
                          <b-field v-if="data.STATUS == 2">
                            <b-button type="is-warning" size="is-small"
                              >ສົ່ງແຜນໄປ dpp Center ແລ້ວ
                            </b-button>
                          </b-field>
                          <b-field v-else-if="data.STATUS == 3">
                            <b-button type="is-warning" size="is-small"
                              >ສົ່ງແຜນໄປ dpp ສາຂາແລ້ວ
                            </b-button>
                          </b-field>
                          <b-field v-else-if="data.STATUS == 4">
                            <b-button type="is-warning" size="is-small"
                              >dpp ສາຂາໄດ້ຮັບແຜນແລ້ວ, ຢູ່ໃນຂະບວນການຜະລິດ
                            </b-button>
                          </b-field>
                        </td>

                        <td class="has-text-centered">
                          <b-field group>
                            <b-field>
                              <b-button
                                class="btn-group-margin"
                                type="is-primary"
                                size="is-small"
                                @click="
                                  quotadetailform(
                                    data.ID,
                                    data.B2BUSERNAME,
                                    data.CONTRACTNO,
                                    data.SUBCONTRACTNO,
                                    data.CONTRACTDATE,
                                    data.SELECTEDDPPBRANCHID,
                                    data.SELECTEDDPPPROVINCE,
                                    data.STATUS
                                  )
                                "
                                >ລາຍລະອຽດ
                              </b-button>
                            </b-field>
                          </b-field>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-tab-item>
                <b-tab-item label="ຜະລິດສຳເລັດ">
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="10%">
                          ສັນຍາເລກທີ/ <br />ເລກທີຍ່ອຍ
                        </th>
                        <th class="has-text-left " width="10%">
                          ວັນທີສັນຍາ
                        </th>
                        <th class="has-text-left " width="15%">
                          ວັນທີສົ່ງລາຍການ
                        </th>
                        <th class="has-text-left " width="10%">
                          ຈຳນວນ<br />ຜະລິດ/ເກັບກ່ຽວ
                        </th>
                        <th class="has-text-left " width="25%">
                          ສະຖານທີ່ຮັບສິນຄ້າ
                        </th>
                        <!-- <th class="has-text-left " width="10%">
                            ລາຍລະອຽດ
                          </th> -->
                        <th class="has-text-centered " width="10%">
                          ສະຖານະ
                        </th>
                        <th class="has-text-centered " width="10%">
                          ຈັດການ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in contractlist_harvest"
                        :key="data.ID"
                      >
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td>{{ data.CONTRACTNO }}/ {{ data.SUBCONTRACTNO }}</td>
                        <td>
                          {{ dateFormatter(data.CONTRACTDATE) }}
                        </td>
                        <td>
                          {{ dateFormatter(data.SUMMITDATE) }}
                        </td>
                        <td>
                          {{ data.NUMBEROFPRODUCTS }} / {{ data.NUMOFHARVEST }}
                        </td>
                        <td>
                          {{ data.PROVINCENAME }} {{ data.DISTRICT }}
                          {{ data.VILLAGE }}
                        </td>
                        <!-- <td>
                            {{ data.DETAIL }}
                          </td> -->
                        <td class="has-text-centered">
                          <b-field
                            v-if="
                              data.STATUS >= 4 &&
                                data.NUMOFHARVEST == data.NUMBEROFPRODUCTS
                            "
                          >
                            <b-button type="is-warning" size="is-small"
                              >ຜະລິດສຳເລັດ
                            </b-button>
                          </b-field>
                          <b-field
                            v-else-if="
                              data.STATUS >= 3 &&
                                data.NUMOFHARVEST > 0 &&
                                data.NUMOFHARVEST != data.NUMBEROFPRODUCTS
                            "
                          >
                            <b-button type="is-warning" size="is-small"
                              >ສຳເລັດບາງລາຍການ
                            </b-button>
                          </b-field>
                        </td>

                        <td class="has-text-centered">
                          <b-field group>
                            <b-field>
                              <b-button
                                class="btn-group-margin"
                                type="is-primary"
                                size="is-small"
                                @click="
                                  quotadetailform(
                                    data.ID,
                                    data.B2BUSERNAME,
                                    data.CONTRACTNO,
                                    data.SUBCONTRACTNO,
                                    data.CONTRACTDATE,
                                    data.SELECTEDDPPBRANCHID,
                                    data.SELECTEDDPPPROVINCE,
                                    data.STATUS
                                  )
                                "
                                >ລາຍລະອຽດ
                              </b-button>
                            </b-field>
                          </b-field>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-tab-item>
              </b-tabs>
            </b-field>
          </b-filed>
        </b-tab-item>

        <b-tab-item label="ຟອມໂຄຕ້າ">
          <b-field v-if="b2busername === null">
            <button class="button is-info" @click="gotoB2Blist">
              ເລືອກ B2B
            </button>
          </b-field>
          <b-filed v-else>
            <div class="columns">
              <div class="column">
                <b-field group>
                  <h3 class="title">
                    {{ b2busername }}, ເລກທີສັນຍາ: {{ contractno }}/
                    {{ subcontractno }}
                  </h3>
                </b-field>
              </div>
            </div>
            <b-filed v-if="isContractProductList">
              <b-field group>
                <b-field label="ລາຍການສິນຄ້າໃນສັນຍາ"></b-field>
                <b-field style="margin: 0 10px 0 10px;">
                  <b-button
                    v-if="isContractProductList && contractstatus == 1"
                    class="btn-group-margin"
                    type="is-info"
                    size="is-small"
                    @click="openContractQuotaForm()"
                    >ເປີດຟອມປ້ອນໂຄຕາ
                  </b-button>

                  <b-button
                    v-if="contractstatus == 1 && contractproductlist.length > 0"
                    class="btn-group-margin"
                    type="is-primary"
                    size="is-small"
                    @click="confirmContractProducts()"
                    >ຢືນຢັນລາຍການໃນສັນຍາ (ສົ່ງເຂົ້າຖານຜະລິດ)
                  </b-button>

                  <b-button
                    v-if="contractstatus == 2"
                    class="btn-group-margin"
                    type="is-danger"
                    size="is-small"
                    @click="cancelConfirmContractProducts()"
                    >ຍົກເລີກລາຍການ ສົ່ງເຂົ້າຖານຜະລິດ
                  </b-button>
                </b-field>
              </b-field>
              <table class="table is-fullwidth is-narrow is-small">
                <thead>
                  <tr>
                    <th class="has-text-centered " width="5%">#</th>
                    <th class="has-text-left " width="15%">
                      ເກັບຜົນຜະລິດ
                    </th>
                    <th class="has-text-left " width="15%">
                      ປະເພດ
                    </th>
                    <th class="has-text-left " width="15%">
                      ສິນຄ້າ
                    </th>
                    <th class="has-text-left " width="15%">
                      ຈຳນວນ
                    </th>
                    <th class="has-text-centered " width="15%">
                      ສະຖານະ
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in contractproductlist"
                    :key="data.B2BID"
                  >
                    <td class="has-text-centered">{{ index + 1 }}</td>
                    <td>
                      {{ dateFormatter(data.REDATE) }}
                    </td>
                    <td>
                      {{ data.TYPENAME }}
                    </td>
                    <td>
                      {{ data.PRODUCTNAME }}
                    </td>
                    <td>{{ data.B2BAMOUNT }} {{ data.UNIT }}</td>
                    <td class="has-text-centered">
                      <b-field group>
                        <b-field v-if="data.B2BSTATUS == 1">
                          <b-button type="is-warning" size="is-small"
                            >ຍັງບໍ່ທັນຜະລິດ
                          </b-button>
                        </b-field>
                        <b-field
                          v-if="data.B2BSTATUS == 1"
                          style="margin: 0 10px 0 10px;"
                        >
                          <b-button
                            class="btn-group-margin"
                            type="is-danger"
                            size="is-small"
                            @click="
                              unSetProductAmount(data.PRODUCTID, data.REDATE, 1)
                            "
                            >ລ້າງໂຄຕາ
                          </b-button>
                        </b-field>
                      </b-field>

                      <b-field v-if="data.B2BSTATUS == 1">
                        <b-button type="is-primary" size="is-small"
                          >ລໍຖ້າສົ່ງແຜນ
                        </b-button>
                      </b-field>
                      <b-field v-else-if="data.B2BSTATUS == 2">
                        <b-button type="is-primary" size="is-small"
                          >ສົ່ງແຜນໄປ dpp Center ແລ້ວ
                        </b-button>
                      </b-field>
                      <b-field v-else-if="data.B2BSTATUS == 3">
                        <b-button type="is-primary" size="is-small"
                          >ສົ່ງແຜນໄປ dpp ສາຂາ ແລ້ວ
                        </b-button>
                      </b-field>
                      <b-field
                        v-else-if="
                          data.B2BSTATUS == 4 && data.PRODUCTIONSTATUS == 2
                        "
                      >
                        <b-button type="is-primary" size="is-small"
                          >dpp ສາຂາ ຮັບແຜນແລ້ວ
                        </b-button>
                      </b-field>
                      <!-- <b-field v-else-if="data.B2BSTATUS == 4 && data.PRODUCTIONSTATUS == 2">
                        <b-button type="is-primary" size="is-small"
                          >ສົ່ງໄປຜະລິດແລ້ວ
                        </b-button>
                      </b-field> -->
                      <b-field
                        v-else-if="
                          data.B2BSTATUS == 4 && data.PRODUCTIONSTATUS == 3
                        "
                      >
                        <b-button type="is-primary" size="is-small"
                          >ກຳລັງຜະລິດ
                        </b-button>
                      </b-field>
                      <b-field
                        v-else-if="
                          data.B2BSTATUS >= 4 && data.PRODUCTIONSTATUS == 4
                        "
                      >
                        <b-button type="is-info" size="is-small"
                          >ຜະລິດສຳເລັດ
                        </b-button>
                      </b-field>
                      <b-field
                        v-else-if="
                          data.B2BSTATUS == 4 && data.PRODUCTIONSTATUS == null
                        "
                      >
                        <b-button type="is-primary" size="is-small"
                          >ລໍຖ້າຜະລິດ
                        </b-button>
                      </b-field>
                      <!-- {{ data.B2BSTATUS }} - {{ data.PRODUCTIONSTATUS}} -->
                    </td>

                    <!-- <td class="has-text-centered">
                      
                    </td> -->
                  </tr>
                </tbody>
              </table>
            </b-filed>
            <b-filed v-if="!isContractProductList">
              <div class="columns">
                <div class="column">
                  <b-field label="ຟອມໂຄຕ້າ"></b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field class="group">
                    <b-field label="ວັນທີ" style="margin-right: 15px;">
                    </b-field>
                    <b-field>
                      <b-datepicker
                        :date-formatter="dateFormatter"
                        v-model="selecteddate"
                        @input="onSelecteddate"
                      >
                      </b-datepicker>
                    </b-field>
                    <b-field style="margin-left:15px;">
                      <b-button
                        v-if="!isContractProductList"
                        class="btn-group-margin"
                        type="is-info"
                        size="is-small"
                        @click="openContractProductList()"
                        >ເບິ່ງສິນຄ້າໃນສັນຍາທັງໝົດ
                      </b-button>
                    </b-field>
                  </b-field>
                </div>
                <div class="column"></div>
              </div>
              <b-tabs v-model="activeSubTab">
                <b-tab-item
                  :label="type.TYPENAME"
                  v-for="type in productType"
                  :key="type.TYPEID"
                >
                  <div class="columns">
                    <div class="column has-text-right">
                      ສິນຄ້າ
                    </div>
                    <div class="column">
                      ຈຳນວນ
                    </div>
                    <div class="column">
                      ຫົວໜ່ວຍ
                    </div>
                    <div class="column"></div>
                    <div class="column"></div>
                    <div class="column"></div>
                  </div>

                  <div :label="type.TYPENAME">
                    <b-filed
                      v-for="product in products"
                      :key="product.PRODUCTID"
                    >
                      <div
                        class="columns"
                        v-if="type.TYPEID === product.TYPEID"
                      >
                        <div class="column has-text-right">
                          {{ product.PRODUCTNAME }}
                        </div>
                        <div class="column">
                          <b-field v-if="product.B2BAMOUNT === null">
                            <b-input v-model.trim="product.AMOUNT"> </b-input>
                          </b-field>
                          <b-feild v-else>
                            <b-input
                              v-model.trim="product.B2BAMOUNT"
                              disabled="disabled"
                            >
                            </b-input>
                          </b-feild>
                        </div>
                        <div class="column">
                          <b-field group>
                            <b-field>
                              {{ product.UNIT }}
                            </b-field>
                          </b-field>
                        </div>
                        <div class="column">
                          <b-field
                            v-if="product.B2BSTATUS != 1 && contractstatus == 1"
                          >
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="saveProductAmount()"
                              >ບັນທຶກ
                            </b-button>
                          </b-field>
                          <b-field v-if="contractstatus > 1">
                            ສົ່ງແຜນໄປຜະລິດແລ້ວ
                          </b-field>
                          <b-field
                            v-if="product.B2BSTATUS == 1"
                            style="margin: 0 10px 0 10px;"
                          >
                            <b-button
                              class="btn-group-margin"
                              type="is-warning"
                              size="is-small"
                              @click="
                                unSetProductAmount(product.PRODUCTID, '', 0)
                              "
                              >ລ້າງໂຄຕາ
                            </b-button>
                          </b-field>
                        </div>

                        <div class="column"></div>
                        <div class="column"></div>
                        <div class="column"></div>
                      </div>
                    </b-filed>
                  </div>

                  <div class="columns">
                    <div class="column"></div>

                    <div class="column">
                      <b-field group>
                        <b-field>
                          <b-button
                            class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="saveProductAmount()"
                            >ບັນທຶກ
                          </b-button>
                        </b-field>
                        <b-field>
                          <b-button
                            class="btn-group-margin"
                            type="is-warning"
                            size="is-small"
                            @click="unSetProductsAmount(type.TYPEID)"
                            >ລ້າງໂຄຕາ
                          </b-button>
                        </b-field>
                      </b-field>
                    </div>

                    <div class="column"></div>
                    <div class="column"></div>
                  </div>
                </b-tab-item>
              </b-tabs>
            </b-filed>
          </b-filed>
        </b-tab-item>

        <b-tab-item label="ໂຄຕາທີ່ສົ່ງຜະລິດ">
          <b-field v-if="b2busername === null">
            <button class="button is-info" @click="gotoB2Blist">
              ເລືອກ B2B
            </button>
          </b-field>
          <b-filed v-else>
            <div class="columns">
              <div class="column">
                <h3 class="title">{{ b2busername }}</h3>
              </div>
            </div>
            <b-tabs v-model="activeQuotaSubTab">
              <b-tab-item label="ໂຄຕາທີ່ສົ່ງຜະລິດ">
                <div class="columns scrollme">
                  <div class="column">
                    <b-field>
                      <table class="table is-fullwidth is-narrow is-small">
                        <thead>
                          <tr>
                            <th class="has-text-centered " width="5%">#</th>
                            <th class="has-text-left " width="15%">
                              ວັນທີ
                            </th>
                            <th class="has-text-left " width="15%">
                              ຈຳນວນປະເພດ
                            </th>
                            <th class="has-text-left " width="15%">
                              ຈຳນວນສິນຄ້າ
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(data, index) in quotaltoproduction"
                            :key="data.REDATE"
                          >
                            <td class="has-text-centered">{{ index + 1 }}</td>
                            <td>
                              <a @click="quotadatededtailtab(data.REDATE)">{{
                                dateFormatter(data.REDATE)
                              }}</a>
                            </td>
                            <td>
                              {{ data.COUNTTYPE }}
                            </td>
                            <td>
                              {{ data.COUNTPRODUCT }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-field>
                  </div>
                </div>
              </b-tab-item>
              <b-tab-item label="ລາຍລະອຽດ">
                <b-field v-if="quotadate === null">
                  <button class="button is-info" @click="gotoquotadate">
                    ເລືອກວັນທີ
                  </button>
                </b-field>
                <b-filed v-else>
                  <b-field label="ວັນທີ" style="margin-right: 15px;"> </b-field>
                  <b-field>
                    <b-datepicker
                      :date-formatter="dateFormatter"
                      v-model="selectedquotaddate"
                      @input="onSelectedquotaldate"
                    >
                    </b-datepicker>
                  </b-field>
                  <b-filed
                    v-for="quotadatetype in quotadatetypes"
                    :key="quotadatetype.TYPEID"
                  >
                    <div class="column">
                      {{ quotadatetype.TYPENAME }}

                      <table class="table is-fullwidth is-narrow is-small">
                        <thead>
                          <tr>
                            <th class="has-text-centered " width="5%">#</th>
                            <th class="has-text-left " width="15%">
                              ສິນຄ້າ
                            </th>
                            <th class="has-text-left " width="15%">
                              ໂຄຕ້າ
                            </th>
                            <th class="has-text-left " width="15%">
                              ກຳລັງຜະລິດ
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="quotadateproduct in quotadateproducts"
                            :key="quotadateproduct.PRODUCTID"
                          >
                            <td
                              class="has-text-centered"
                              v-if="
                                quotadatetype.TYPEID === quotadateproduct.TYPEID
                              "
                            >
                              {{ quotadateproduct.NUM }}
                            </td>

                            <td
                              v-if="
                                quotadatetype.TYPEID === quotadateproduct.TYPEID
                              "
                            >
                              {{ quotadateproduct.PRODUCTNAME }}
                            </td>
                            <td
                              v-if="
                                quotadatetype.TYPEID === quotadateproduct.TYPEID
                              "
                            >
                              {{ quotadateproduct.AMOUNT }}
                              {{ quotadateproduct.UNIT }}
                            </td>
                            <td
                              v-if="
                                quotadatetype.TYPEID === quotadateproduct.TYPEID
                              "
                            ></td>
                          </tr>
                        </tbody>
                      </table>
                      <!-- <b-filed class="columns" v-if="type.TYPEID === product.TYPEID">
                            </b-filed> -->
                    </div>
                  </b-filed>
                </b-filed>
              </b-tab-item>
            </b-tabs>
          </b-filed>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,

      activeb2b: [],
      // inactivemarkets: [],
      b2buserid: null,
      b2busername: null,

      activeTab: 0,
      saveAction: true,
      updateAction: false,
      adddataform: true,
      updatedataform: false,

      activeSubTab: 0,
      productType: [],
      products: [],
      productamount: [],
      selecteddate: null,

      quotaltoproduction: [],
      activeQuotaSubTab: 0,
      quotadate: null,
      quotadatetypes: null,
      quotadateproducts: null,
      selectedquotaddate: null,
      contractid: null,
      contractno: null,
      subcontractno: null,
      countryList: [],
      SelectedCountry: null,
      ProvinceList: [],
      SelectedProvince: null,
      district: null,
      village: null,
      contractstatus: null,
      contractdate: null,
      contractdetail: null,
      contractlist_waittoproduce: [],
      contractlist_producing: [],
      contractlist_harvest: [],
      isContractProductList: false,
      contractproductlist: [],

      activeQuotaProgressTab: 0,

      DppProvinceList: [],
      SelectedDppProvince: null,
      stockList: [],
      selectedStock: null,

      selectedProvinceid: null,
      selectedBranchid: null,
      
    };
  },
  methods: {

    getCountry() {
      RestAPI.getCountry()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.countryList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    saveContract() {
      if (
        this.contractno === null ||
        this.subcontractno === null ||
        this.selecteddate === null ||
        this.SelectedCountry === null ||
        this.SelectedProvince === null ||
        this.district === null ||
        this.village === null ||
        this.SelectedDppProvince === null ||
        this.selectedStock === null
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else {
        var params = {
          b2busername: this.b2busername,
          contracttype: 2, // production plan
          contractno: this.contractno,
          subcontractno: this.subcontractno,
          contractdate: this.dateFormatterYYYYMMDD(this.selecteddate),
          provinceid: this.SelectedProvince.ID,
          district: this.district,
          village: this.village,
          detail: this.contractdetail,
          dppprovinceid: this.SelectedDppProvince.DPPPROVINCEID,
          ddppbranchid: this.SelectedDppProvince.DPPBRANCEID,
          stockid: this.selectedStock.ID,
          username: this.username,
        };
        // console.log("params: " + JSON.stringify(params));
        RestAPI.saveContract(params)
          .then((res) => {
            // console.log("data: " + JSON.stringify(res.data))
            if (res.data == "duplicate b2bcontract") {
              this.$swal("ສັນຊາຊໍ້ຳ", "-", "error");
              return false;
            }

            this.getContractByB2bUser(this.b2busername);
            this.$swal("ບັນທຶກສັນຍາ ສຳເລັດ!", "", "success");
            this.saveAction = true;
            this.updateAction = false;
            this.selecteddate = null;
            this.contractno = null;
            this.subcontractno = null;
            this.detail = null;
            this.selectedCountry = null;
            this.SelectedProvince = null;
            this.district = null;
            this.village = null;
            this.SelectedDppProvince = null;
            this.selectedStock = null;
            // console.log(res);
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    getContractByB2bUser(b2busername) {
      RestAPI.getContractByB2bUser(b2busername, 2)
        .then((res) => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.contractlist_waittoproduce = res.data.waittoproduce;
          this.contractlist_producing = res.data.producing;
          this.contractlist_harvest = res.data.harvest;
          // this.inactivemarkets = res.data.inactivemarkets;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getB2bUser() {
      RestAPI.getB2bUser(this.username)
        .then((res) => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.activeb2b = res.data;
          // this.inactivemarkets = res.data.inactivemarkets;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getProductType() {
      RestAPI.getProductType()
        .then((res) => {
          this.productType = res.data.activeProductType;
          // console.log("prodcuttype: " + JSON.stringify(this.productType));
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getContractProducts() {
      RestAPI.getContractProducts(
        this.contractid,
        this.dateFormatterYYYYMMDD(this.selecteddate)
      )
        .then((res) => {
          this.products = res.data;
          // console.log("products: " + JSON.stringify(this.products));
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    contractform(B2BUSERID, B2BUSERNAME, ISNOTMOVE = null) {
      if (ISNOTMOVE != 1) {
        this.activeTab = 1;
      }

      this.b2buserid = B2BUSERID;
      this.b2busername = B2BUSERNAME;
      this.getContractByB2bUser(B2BUSERNAME);
    },
    quotadetailform(
      CONTRACTID,
      B2BUSERNAME,
      CONTRACTNO,
      SUBCONTRACTNO,
      CONTRACTDATE,
      SELECTEDDPPBRANCHID,
      SELECTEDDPPPROVINCE,
      STATUS
    ) {
      this.contractproductlist = null;
      this.activeTab = 2;
      this.contractid = CONTRACTID;
      this.contractno = CONTRACTNO;
      this.subcontractno = SUBCONTRACTNO;
      this.contractdate = CONTRACTDATE;
      this.b2busername = B2BUSERNAME;
      this.selectedBranchid = SELECTEDDPPBRANCHID;
      this.selectedProvinceid = SELECTEDDPPPROVINCE;
      this.contractstatus = STATUS;
      this.getContractProducts();
      this.openContractProductList();
      console.log("STATUS: " + STATUS);
      // console.log("redate: " + this.dateFormatterYYYYMMDD(this.selecteddate));
    },
    gotoB2Blist() {
      this.activeTab = 0;
    },
    // quotaToProduction(ID, MARTKETNAME){
    //   this.activeTab = 2;
    //   this.marketid = ID;
    //   this.marketname = MARTKETNAME;

    //   RestAPI.getProductToProduction(this.marketid)
    //     .then(res => {
    //       this.quotaltoproduction = res.data;
    //     })
    //     .catch(error => {
    //       console.log(error);
    //       this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //     });
    // },
    gotoquotadate() {
      this.activeQuotaSubTab = 0;
    },

    onSelecteddate() {
      this.getContractProducts();
      // this.formdate = this.dateFormatterYYYYMMDD(this.selecteddate);
      // console.log(this.formdate);
    },
    // onSelectedquotaldate() {
    //   this.quotadatededtailtab(this.dateFormatterYYYYMMDD(this.selectedquotaddate))
    //   console.log("this.dateFormatterYYYYMMDD(this.selectedquotaddate): " + this.dateFormatterYYYYMMDD(this.selectedquotaddate))
    // },
    saveProductAmount() {
      //  console.log("this.formdate: "+ this.formdate)
      if (this.selecteddate == null) {
        this.$swal("ກະລູນາປ້ອນຈຳນວນວັນທີ", "", "error");
      }
      var params = {
        redate: this.dateFormatterYYYYMMDD(this.selecteddate),
        b2busername: this.b2busername,
        contractid: this.contractid,
        contractno: this.contractno,
        products: this.products,
        username: this.username,
      };

      // console.log("params: ", JSON.stringify(params))

      RestAPI.saveB2BQuotaProductAmount(params)
        .then((res) => {
          console.log("res: " + JSON.stringify(res.data));

          if (res.data.result > 0) {
            this.$swal("ບັນທືກ ສຳເລັດ!", "", "success");
          } else {
            this.$swal("ກະລຸນາປ້ອນຢ່າງໜ້ອຍ 1 ລາຍການ!", "", "warning");
          }

          this.getContractProducts();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    unSetProductsAmount(type) {
      //  console.log("this.formdate: "+ this.formdate)
      var params = {
        redate: this.dateFormatterYYYYMMDD(this.selecteddate),
        contractid: this.contractid,
        typeid: type,
        username: this.username,
      };

      RestAPI.unSetContractProductsAmount(params)
        .then(() => {
          this.$swal("ລ້າງໂຄຕ້າ ສຳເລັດ!", "", "success");
          this.getContractProducts();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    unSetProductAmount(productid, redate, type) {
      //  console.log("this.formdate: "+ this.formdate)
      var params = {
        redate: redate
          ? this.dateFormatterYYYYMMDD(redate)
          : this.dateFormatterYYYYMMDD(this.selecteddate),
        contractid: this.contractid,
        productid: productid,
        username: this.username,
      };

      console.log("par: " + JSON.stringify(params));

      RestAPI.unSetContractProductAmount(params)
        .then(() => {
          this.$swal("ລ້າງໂຄຕ້າ ສຳເລັດ!", "", "success");
          if (type == 1) {
            this.openContractProductList();
          }

          this.getContractProducts();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    openContractProductList() {
      this.isContractProductList = true;
      // console.log("this.contractid: " + this.contractid)
      RestAPI.getContractProductList(this.contractid)
        .then((res) => {
          this.contractproductlist = res.data;
          // console.log("products: " + JSON.stringify(res.data));
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    openContractQuotaForm() {
      this.isContractProductList = false;
    },
    confirmContractProducts() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            contractid: this.contractid,
            branchid: this.selectedBranchid,
            provinceid: this.selectedProvinceid,
            username: this.username,
          };
          RestAPI.confirmContractProducts(params)
            .then(() => {
              this.$swal("ຢືນຢັນລາຍການສິນຄ້າໃນສັນຍາ ສຳເລັດ!", "", "success");
              this.openContractProductList();
              this.contractstatus = 2;
              this.contractform(this.b2buserid, this.b2busername, 1);
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    cancelConfirmContractProducts() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            contractid: this.contractid,
            username: this.username,
          };
          RestAPI.cancelConfirmContractProducts(params)
            .then(() => {
              this.$swal(
                "ຍົກເລີກການຢືນຢັນລາຍການສິນຄ້າ ໃນສັນຍາ ສຳເລັດ!",
                "",
                "success"
              );
              this.openContractProductList();
              this.contractstatus = 1;
              this.contractform(this.b2buserid, this.b2busername, 1);
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    onCountrySelected() {
      RestAPI.getProvincebyCountry(this.SelectedCountry.ID)
        .then((res) => {
          // console.log("country selected...")
          this.ProvinceList = res.data;
          this.SelectedProvince = null;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getDppProvince() {
      RestAPI.getDppProvince()
        .then((res) => {
          // console.log("country selected...")
          this.DppProvinceList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getStockList() {
      RestAPI.getStockList(this.username)
        .then((res) => {
          console.log("getStockList : " + JSON.stringify(res.data))
          this.stockList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getProvince() {
      RestAPI.getProvincebyCountry(this.selectedCountry.ID)
        .then((res) => {
          // console.log("country selected...")
          this.provinceList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    print() {
      window.print();
    },
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.getB2bUser();
    this.getCountry();
    this.getProductType();
    this.selecteddate = new Date();
    this.selectedquotaddate = new Date();
    this.formdate = new Date();
    this.getDppProvince();
    this.getStockList();
  },
  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.asterisk {
  color: red;
}
</style>
